import React from 'react';

import Close from '../../../images/Close';
import coffee from '../../../images/Coffee2.png';
import coffeeMobile from '../../../images/Coffee2Mobile.png';
import { AnimatedModal } from '../../Modal/index';

import SignUpForm from './';

import style from './Popup.scss';

const SUBSCRIBED_COOKIE_NAME = 'tsr_subscribed_at';

const isSubscribed =
  typeof document === 'undefined' ? false : document.cookie.includes(SUBSCRIBED_COOKIE_NAME);

const SignUpPopup = (props: {
  closeOnEscape?: boolean;
  showOnExitIntent?: boolean;
  timeout?: number;
}) => {
  const { closeOnEscape = true, showOnExitIntent = true, timeout = 2000 } = props;

  const [isShown, setIsShown] = React.useState(false);
  const [isMounted, setIsMounted] = React.useState(false);

  const handleShow = () => {
    setIsShown(true);
    setIsMounted(true);
  };

  const handleClose = () => {
    localStorage.setItem('signup_popup_close_timeout', (new Date().getTime() + 172800).toString());

    setTimeout(() => {
      setIsShown(false);
    }, 300);
  };

  const handleMouseLeave = (event: any) => {
    const hiddenTimeoutDate = localStorage.getItem('signup_popup_close_timeout');

    const isOutOfWindow = event.clientY < 0;

    const isSubscribed = document.cookie.includes(SUBSCRIBED_COOKIE_NAME);

    if (
      // not already closed
      (!hiddenTimeoutDate ||
        (hiddenTimeoutDate &&
          new Date().getTime() - new Date(+hiddenTimeoutDate).getTime() >= 0)) &&
      isOutOfWindow &&
      !isSubscribed
    ) {
      handleShow();
    }
  };

  const handleEscapeKey = (event: KeyboardEvent) => {
    event = event || window.event;
    if (event.keyCode === 27) {
      handleClose();
    }
  };

  const handleSubmit = () => {
    setTimeout(() => {
      handleClose();
    }, 1000);
  };

  React.useEffect(() => {
    const hiddenTimeoutDate = localStorage.getItem('signup_popup_close_timeout');

    if (
      isSubscribed ||
      window?.location.pathname === '/subscribe/' ||
      window?.location.pathname === '/email-subscriber-survey/' ||
      window?.location.pathname === '/crediyfi-reviews/' ||
      window?.location.pathname === '/personal-loans-payday-loans/' ||
      window?.location.pathname === '/best-payday-loans-online/' ||
      window?.location.pathname === '/lendjet-review/' ||
      window?.location.pathname === '/amone-reviews/' ||
      window?.location.pathname === '/stats/' ||
      window?.location.pathname === '/myappfree-1/' ||
      window?.location.pathname === '/raisin-1/' ||
      window?.location.pathname === '/lemonade-1/'
    ) {
      setIsShown(false);
    } else if (
      !hiddenTimeoutDate ||
      (hiddenTimeoutDate && new Date().getTime() - new Date(+hiddenTimeoutDate).getTime() >= 0)
    ) {
      if (showOnExitIntent) {
        document.addEventListener('mouseout', handleMouseLeave);
      } else {
        const readyStateCheckInterval = setInterval(() => {
          if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            setTimeout(() => {
              handleShow();
            }, timeout);
          }
        }, 1000);
      }
    } else if (isShown) {
      setIsShown(false);
    }

    // Escape closes popup
    if (closeOnEscape) {
      document.addEventListener('onkeydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('mouseout', handleMouseLeave);
      document.removeEventListener('onkeydown', handleEscapeKey);
    };
  }, []);

  const tags = ['Popup', 'Exit Intent'];

  if (showOnExitIntent) tags.push('Exit Intent');

  if (!isMounted) return null;

  return (
    <AnimatedModal isShown={isShown} onClose={handleClose} bodyClassName={style.modalBody}>
      <div className={style.contentWrapper}>
        <img className="d-none d-xl-block" src={coffee} width="360px" height="440px"></img>
        <img className="d-xl-none" src={coffeeMobile} width="378px" height="293px"></img>
        <div className={style.content}>
          <h3>Ready to Take Control of Your Finances?</h3>
          <p>
            Receive expert tips on investing, saving, and building financial freedom—delivered
            straight to your inbox.
          </p>
          <div className={style.form}>
            <SignUpForm btnText="Start Building Wealth" callBack={handleSubmit} tags={tags}>
              <p>Thank You!</p>
            </SignUpForm>
          </div>
          <p>
            By clicking 'Start Building Wealth,' you agree to our{' '}
            <a target="_blank" href="/terms-and-conditions">
              Terms of Use
            </a>{' '}
            &{' '}
            <a target="_blank" href="/privacy-policy">
              Privacy Policy
            </a>
            .
          </p>
        </div>
        <span className={style.close} onClick={handleClose}>
          <Close width={12} height={12} />
        </span>
      </div>
    </AnimatedModal>
  );
};

export default SignUpPopup;
